import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../blog.css";
import butter from "../../elements/butterClient/butterClient.js";
import BlogMenu from "../menu/blogMenu.js";
import BlogCard from "../card/blogCard.js";
import { Columns, Container } from "../../elements"
import MetaTags from "../../elements/meta/metaTags.js";
import { trackPageView } from "../../elements/tracking/pagesAndMarketingTracking";

class Blog extends Component {
  state = {
    meta: {},
    data: [],
    loading: true
  };

  async componentDidMount() {
    const { match } = this.props
    document.body.classList.add("blog")
    let page = match.params.page || 1
    trackPageView('Blog Home', 'Blog')

    let butterParams = {
      page: page,
      page_size: 9,
      exlude_body: true,
      order: ""
    };

    try {
      const resp = await butter.post.list(butterParams)
      this.setState({
        data: resp.data.data,
        meta: resp.data.meta,
        loading: false
      })
    } catch (error) {
      this.setState({
        loading: false
      })
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("blog")
  }

  render() {
    const { next_page, previous_page } = this.state.meta;
    const { loading } = this.state
    const { isMobile } = this.props.isMobile
    return (
      <React.Fragment>
        <MetaTags
          title={
            "Twisted Wrote : The Twisted Road Blog. Company updates, Community stories, and more."
          }
          description={
            "Explore Twisted Road news, community features, motorcycle advice and reviews, and expert motorcycle talk."
          }
          url={"/blog"}
          type={"Company"}
          //image_id=
          facebookDescription={
            "Explore Twisted Road news, community features, motorcycle advice and reviews, and expert motorcycle talk."
          }
          fetch={false}
        />

        <BlogMenu isMobile={isMobile}  />

        {!loading && (
          <Container className="large mt-0">
            <Columns className="is-6 is-variable">
              {this.state.data.map((post, key) => {
                return <BlogCard post={post} key={key} showSummary={false} isMobile={isMobile}/>
              })}
            </Columns>
            <Columns breakpoint="mobile" className="is-mobile">
              <Columns.Column mobile={{ size: 6 }} tablet={{ size: 6 }}>
                {previous_page && (
                  <a
                    href={`/blog/${previous_page}`}
                    className="button is-black is-medium is-outlined"
                  >
                    <span className="icon">
                      <i className="fas fa-arrow-left"></i>
                    </span>
                    <span>Newer Posts</span>
                  </a>
                )}
              </Columns.Column>
              <Columns.Column
                mobile={{ size: 6 }}
                tablet={{ size: 6 }}
                className="has-text-right"
              >
                {next_page && (
                  <a
                    href={`/blog/${next_page}`}
                    className="button is-black is-medium is-outlined"
                  >
                    <span>Older Posts</span>
                    <span className="icon">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </a>
                )}
              </Columns.Column>
            </Columns>
          </Container>
        )}
      </React.Fragment>
    )
  }
}

export default withRouter(Blog);
